import React from "react";

import { AlertType } from "@constants";

import { IconOld } from ".";

interface Props {
  type?: string;
  title?: string;
  text: string;
  className?: string;
  noPadding?: boolean;
  alertSource?: string;
  textAttributes?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
}

const INFO_BG = "bg-transparent";
const INFO_ICON = "info-circle-grey";

const Alert: React.FC<Props> = ({
  type = AlertType.Info,
  title,
  text,
  className = "",
  noPadding,
  alertSource = "0",
  textAttributes,
}) => {
  const getBgColor = () => {
    if (type === AlertType.Info) return INFO_BG;
    if (type === AlertType.Warning) return "bg-white";
    if (type === AlertType.Error) return "bg-red-5";
    if (type === AlertType.Success) return "bg-success-background";
    return INFO_BG;
  };

  const getIconName = (): IconName => {
    if (type === AlertType.Info) return INFO_ICON;
    if (type === AlertType.Warning) return "info-circle-red";
    if (type === AlertType.Error) return "cross-mark";
    if (type === AlertType.Success) return "check-circle";
    return INFO_ICON;
  };

  const getFillColor = () => {
    if (type === AlertType.Info) return "fill-grey-80";
    if (type === AlertType.Warning) return "fill-red-corporate";
    if (type === AlertType.Error) return "fill-red-corporate";
    if (type === AlertType.Success) return "fill-success-icon";
    return INFO_ICON;
  };

  const getTitle = () => {
    if (type === AlertType.Info) return title;
    if (type === AlertType.Warning) return title;
    if (type === AlertType.Error) return title;
    if (type === AlertType.Success) return title;
    return INFO_ICON;
  };

  return (
    <div
      data-testid={`alert-${alertSource}`}
      className={`flex items-start rounded-sm ${
        noPadding ? `p-0` : `py-3 px-4`
      } ${getBgColor()} ${className}`}
    >
      <IconOld name={getIconName()} className={`mr-3 h-6 w-6 shrink-0 ${getFillColor()}`} />
      <div className="break-words text-xs" {...textAttributes}>
        {title && <span className="mr-1 font-bold">{getTitle()}:</span>}
        {text}
      </div>
    </div>
  );
};

export default Alert;
